<template>
  <div class="app-container">
    <!-- <div class="summary-bar">
      <div class="summary-item">
        <span class="label">记录总数</span>
        <span class="value">{{ totalRecords }}</span>
      </div>
      <div class="summary-item">
        <span class="label">增重总计 (kg)</span>
        <span class="value" style="color: #67c23a;">{{ totalIncrease.toFixed(2) }}</span>
      </div>
      <div class="summary-item">
        <span class="label">减重总计 (kg)</span>
        <span class="value" style="color: #f56c6c;">{{ totalDecrease.toFixed(2) }}</span>
      </div>
    </div> -->

    <div class="search-bar">
      <el-form :inline="true" :model="searchParams">
        <el-form-item>
          <el-input placeholder="设备编号" v-model="searchParams.deviceNo" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-download">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="data-table">
      <el-table :data="weightRecordsData" border fit highlight-current-row style="width: 100%" :cell-style="centerCellStyle" :header-cell-style="centerHeaderStyle">
        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="device_code" label="设备编号" width="160" align="center" />
        <el-table-column label="重量" width="120" align="center">
          <template slot-scope="{row}">
            {{ row.weight }} {{ row.unit || 'kg' }}
          </template>
        </el-table-column>
        <el-table-column prop="weight_type" label="变化类型" width="120" align="center">
          <template slot-scope="{row}">
            <el-tag :type="row.weight_type === 'INCREASE' ? 'success' : 'danger'">{{ row.weight_type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="240" align="center" />
        <el-table-column prop="created_at" label="记录时间" width="180" align="center" />
      </el-table>
    </div>
    
    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="pagination.currentPage"
        :page-size="pagination.page_size"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getDeviceWeightLogs } from '@/api/deviceWeightLogs'
export default {
  name: 'WeightRecords',
  data() {
    return {
      searchParams: {
        deviceNo: '',
        deviceType: '',
        dateRange: []
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalRecords: 0,
      totalIncrease: 0,
      totalDecrease: 0,
      chartData: [],
      weightRecordsData: []
    }
  },
  mounted() {
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      const params = {
        page: this.pagination.currentPage,
        size: this.pagination.page_size,
        device_code: this.searchParams.deviceNo || undefined
      }
      try {
        const res = await getDeviceWeightLogs(params)
        if ((res.code === 0 || res.code === 'SUCCESS') && res.data) {
          this.weightRecordsData = res.data.logs || [];
          this.totalRecords = res.data.total || 0;
          this.pagination.currentPage = res.data.page || 1;
          this.pagination.page_size = res.data.size || this.pagination.page_size;

          // Mock data for summary
          this.totalIncrease = res.data.total_increase || 0;
          this.totalDecrease = res.data.total_decrease || 0;
        } else {
          this.$message.error('获取重量记录失败：' + (res.message || '未知错误'))
        }
      } catch (error) {
        console.error('获取重量记录失败:', error)
        this.$message.error('获取重量记录失败，请稍后重试')
      }
    },
    // 搜索重量记录
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchLogs()
    },
    
    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        deviceNo: '',
        deviceType: '',
        dateRange: []
      }
      this.pagination.currentPage = 1
      this.fetchLogs()
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.page_size = size
      this.fetchLogs()
    },
    
    // 当前页码变化
    handleCurrentChange(current) {
      this.pagination.currentPage = current
      this.fetchLogs()
    },

    // 列表内容居中样式
    centerCellStyle() {
      return { textAlign: 'center' }
    },
    centerHeaderStyle() {
      return { textAlign: 'center' }
    }
  }
}
</script>

<style scoped>
.app-container {
  background-color: #f0f2f5;
}

.summary-bar {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary-item .label {
  color: #606266;
  font-size: 14px;
}

.summary-item .value {
  color: #303133;
  font-size: 24px;
  font-weight: bold;
}

.search-bar {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.data-table {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-wrapper {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-top: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
}
</style>
